/* questo component conterrà solo la label e la select della lista tipo richiedente, gli passerò come prop il setter dal component inserimento richiesto */
import {useState, useContext, useEffect} from 'react';
import { UserContext } from "../../Context/UserContext.js";

import baseUrl from '../../utilities/globalVariables.js'


function TipoIntervento(props){
    const [listaTipi, setListaTipi] = useState([]);
    const userObject = useContext(UserContext);
    const { userId, accessToken} = userObject

    const [tipoIntervento, setTipoIntervento] = [props.tipoIntervento,  props.setTipoIntervento];

    //onload faccio get a lista tipi per polare la select
    useEffect(()=>{
        if(accessToken==null){return}

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("x-user-id", userId);
        myHeaders.append('x-access-token', accessToken);

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        fetch(baseUrl + "/api/v1/richieste/tipointervento ", requestOptions)
        .then(response => response.json())
        .then(result => {
            //console.log("lista tipiInterventi", result.message)
            if(result.message != undefined){
                setListaTipi(result.message)
            }
        })
        .catch(error => console.log('error', error));
    },[accessToken])

    return(
        <div className="campoInserimentoRichiesta">
            <label>Tipo Intervento</label>
            <select onChange={(e)=>setTipoIntervento(e.target.value)} value={tipoIntervento}>
            {listaTipi.map((tipo)=>{
                    return <option key={tipo.id} value={tipo.id}>{tipo.name}</option>
                })}
            </select>

        </div>
    )
}
export default TipoIntervento;